import PaperHead from '@/apps/question/components/PaperHead.vue'
import QuestionBox from '@/apps/question/components/QuestionBox.vue'
import QuestionType from '@/apps/question/components/QuestionType.vue'
import {
  getQuestionCart,
  listDetail,
  removeUestionFromCart,
  similarSearch,
  switchQuestion,
  updateQuestionCart
} from '@/apps/question/model/api'
import { numToChinese } from '@/apps/question/model/numberToChinese'
import MainTemplate from '@/components/MainTemplate.vue'
import { Add, bubbling } from '@/utils/sort'
import { debounce, throttle } from 'throttle-debounce'
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import AssessmentTrackMixin from '../mixins/assessment-track-mixin'
import {
  assessmentPaperGetPaperId,
  getBooks,
  getSeries,
  getTransEvaluation,
  postTransEvaluation,
  questionScores,
  setScores
} from '../model/api'
import { BASE_GRADES, SUBJECT_MAP, TERM_MAP } from '../model/common'

const usage = 3
let timeback: any = null
const proSource = '题库组卷'
@Component({ components: { MainTemplate, QuestionBox, PaperHead, QuestionType, draggable } })
export default class PPreview extends Mixins(AssessmentTrackMixin) {
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get origin() {
    console.log(this.$route.meta)
    return this.$route.meta && this.$route.meta.origin
  }
  private get subjectId() {
    return this.$store.state.subject && this.$store.state.subject.value
  }
  private get subject() {
    return this.$store.state.subject
  }
  private get titleText() {
    return this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
    this.$store.state.user_info.regions[2].code == 310112 ? '练习' : '测评'
  }
  private get totalScore() {
    let score = 0
    this.paperData.forEach((item) => {
      item.sequence.forEach((n) => {
        score += n.score ? n.score.score : 0
      })
    })
    return score
  }
  private get modalTotalScore() {
    let score = 0
    this.scoreData.forEach((item) => {
      item.sequence.forEach((n) => {
        score += n.score ? n.score : 0
      })
    })
    return score
  }
  private get modalTotalQuestions() {
    let count = 0
    this.scoreData.forEach((item) => {
      count += item.sequence.length
    })
    return count
  }
  private get modalTotalQtypes() {
    return this.scoreData && this.scoreData.length
  }
  private get totalQuestions() {
    let count = 0
    this.paperData.forEach((item) => {
      count += item.sequence.length
    })
    return count
  }
  private get currentQuestion() {
    return this.samilerQuestions.length > 0 ? this.samilerQuestions[this.currentIndex] : {}
  }
  private get selectedSBL() {
    return `${this.serieName}${this.bookName}${this.libName}` || '请选择'
  }
  public BASE_GRADES = BASE_GRADES
  public TERM_MAP = TERM_MAP
  public from = '/assessment'
  public titleFixed = false
  public saveBtnStatus = false
  // 试卷
  public paperData: any = []
  public lazying = false
  public visible = false
  // 试卷信息确认弹窗
  public paperDataModal = false
  public bookSeries = []
  public serie: any = []
  public serieName = ''
  public books = []
  public book: any = []
  public bookName = ''
  public libs = []
  public lib: any = []
  public libName = ''
  private syncBtnLoading = false
  private useType = ''
  private useTypeName = ''
  private useTypeChoices = []
  private submitTableData: any = []
  private modalContext = ''
  private modal = false
  private currentIndex = 0
  private samilerQuestions: any = []
  private loading = false
  private spinning = false
  private columns: any = [
    {
      title: '题号',
      width: '80px',
      dataIndex: 'idx'
    },
    {
      title: '分数',
      dataIndex: 'score',
      slots: 'score',
      width: '80px',
      scopedSlots: { customRender: 'score' }
    },
    {
      title: '分值设置',
      dataIndex: 'sub_scores',
      slots: 'sub_scores',
      scopedSlots: { customRender: 'sub_scores' }
    },
    {
      dataIndex: 'interval_score',
      slots: { title: 'interval_title' },
      width: '90px',
      scopedSlots: { customRender: 'interval_score' }
    }
  ]
  private confirmColumns = [
    {
      key: 'business_type',
      title: '题组',
      dataIndex: 'business_type',
      width: '198px',
      slots: 'business_type',
      scopedSlots: { customRender: 'business_type' }
    },
    {
      key: 'sequence',
      title: '题目数',
      dataIndex: 'sequence',
      width: '198px',
      slots: 'sequence',
      scopedSlots: { customRender: 'sequence' }
    },
    {
      key: 'group_score',
      title: '分数',
      slots: 'group_score',
      dataIndex: 'group_score',
      scopedSlots: { customRender: 'group_score' }
    }
  ]
  private scoreModal = false
  // 换题相关
  private oldQuestionId: string | number = ''
  // 分数设置弹窗
  private scoreData: any = []
  private paper_total_score = 0
  private isBottom = false
  // mounted
  public mounted() {
    this.getCart()
    this.getDetail()
    let self = this
    this.titleFixed = false
    window.addEventListener('scroll', throttle(20, this.handleScroll), true)
    // 注册页面卸载事件
    window.onbeforeunload = (e) => {
      let event = window.event || e
      // event.returnValue = '确定离开当前页面吗？'
      self.$store.commit('SET_CART', {
        classification: {},
        question_ids: []
      })
    }
  }
  //
  public beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false)
  }

  // handleScroll
  public handleScroll() {
    this.$nextTick(() => {
      try {
        let dom: any = document.getElementById('pride_tab_fixed')
        let app: any = document.getElementById('app')
        let offsetTop = dom.getBoundingClientRect().top
        let scrollTop = app.scrollTop
        let clientHeight = app.clientHeight
        let scrollHeight = app.scrollHeight
        // let footerHeight = document.getElementsByClassName('tkn-footer')[0].clientHeight

        this.titleFixed = offsetTop < 0
        if (scrollHeight > clientHeight && scrollTop + clientHeight === (scrollHeight-178)) {
          this.isBottom = true
          console.log('到底了')
        } else {
          this.isBottom = false
        }
      } catch (e) {
        console.log(e)
      }
    })
  }
  public toMyAssessment() {}
  public calcScore(val) {
    let score = 0
    for (let n of val) {
      score += n.score ? n.score.score : 0
    }
    return score
  }
  public calcModalScore(val) {
    let score = 0
    for (let n of val) {
      score += n.score ? n.score : 0
    }
    return score
  }
  public handleCount(val) {
    return numToChinese(val)
  }
  public handleCancelTip() {}
  public prevQuestion() {
    let len = this.samilerQuestions.length
    if (len) {
      this.currentIndex -= 1
    }
  }

  public nextQuestion() {
    let len = this.samilerQuestions.length
    if (len) {
      this.currentIndex += 1
    }
  }
  public async handleOk() {
    let params: any = {
      old_question_id: this.oldQuestionId,
      new_question_id: this.currentQuestion.id,
      subject_id: this.subjectId,
      usage
    }
    let data: any = await switchQuestion(params)
    // 换题成功后同步购物车
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
      this.getDetail() // 刷新页面
      this.handleCancel()
    } else {
      this.$message.warning('换题失败')
    }
  }
  public handleCancel() {
    // 重置
    this.modal = false
    setTimeout(() => {
      this.samilerQuestions = []
      this.currentIndex = 0
      this.oldQuestionId = ''
    }, 200)
  }
  public openAnalysis(itm) {
    itm.showAnalysis = !itm.showAnalysis
  }
  public showTip(text: string) {
    this.visible = true
    this.modalContext = text
  }
  // 点击换题
  public async findSamilerQuestions(id) {
    this.spinning = true

    let param = {
      question_id: id,
      subject_id: this.subjectId,
      question_ids: this.cartInfo.question_ids || []
    }
    let data: any = await similarSearch(param)

    if (data.success) {
      if (!(data.data && data.data.questions && data.data.questions.length)) {
        // this.showTip('我们正在努力制作，敬请期待')
        this.$warning({
          title: '提示',
          content: '我们正在努力制作，敬请期待',
          okText: '确定'
        })
        return
      }
      this.modal = true
      data.data.questions.forEach((q) => {
        q.showAnalysis = true
      })
      this.samilerQuestions = data.data.questions
    } else {
      this.$message.warning(data.error)
    }
    this.spinning = false
  }
  public clickChange(question) {
    this.oldQuestionId = question.id
    this.findSamilerQuestions(this.oldQuestionId)
  }
  public getPosition(idx, data, index, paper) {
    if (index === paper.length - 1 && index === 0) {
      if (idx === 0) {
        if (idx === data.length - 1) {
          return ''
        } else {
          return 'first'
        }
      } else if (idx === data.length - 1) {
        return 'last'
      } else {
        return 'mid'
      }
    } else if (index === paper.length - 1) {
      if (idx === data.length - 1) {
        return 'last'
      } else {
        return 'mid'
      }
    } else if (index === 0) {
      if (idx === 0) {
        return 'first'
      } else {
        return 'mid'
      }
    } else {
      return 'mid'
    }
  }
  //
  public async setCart(data) {
    let params: any = {
      question_cart: data,
      subject_id: this.subjectId,
      usage
    }
    let res: any = await updateQuestionCart(params)
    if (res.success) {
      this.$store.commit('SET_CART', res.data)
    }
  }
  // 上下移动
  public swapItems(arr, index1, index2) {
    arr[index1] = arr.splice(index2, 1, arr[index1])[0]
    return arr
  }
  // 支持跨模块移动
  public move(dir, key, val, idx, data, index, cur) {
    // 跨模块移动
    if (idx === val.length - 1 && dir === -1) {
      // 上面的模块移动到下面
      data[index + 1].sequence.unshift(cur)
      val.splice(idx, 1)
    } else if (idx === 0 && dir === 1) {
      data[index - 1].sequence.push(cur)
      val.splice(idx, 1)
    } else {
      this.swapItems(val, idx, idx - dir)
    }
    this.$nextTick(() => {
      this.updateCart(this.paperData)
    })
  }
  // 获取提交试卷信息
  public async getPaperEvaluationInfo() {
    window['sensors'].track('Assessmentpreview_testinformationpop_loading', {})
    try {
      let sequence: any[] = []
      let data: any = await getTransEvaluation({ subject_id: this.subjectId, usage: 3 })
      console.log(data)
      if (data.success) {
        this.paperDataModal = true
        for (let n of data.data.classification) {
          sequence = [...sequence, ...n.sequence]
        }
        let item = { business_type: '总计', group_score: data.data.total_score, sequence }
        this.submitTableData = [...data.data.classification, item]
        this.useTypeChoices = data.data.use_type_choices
      } else {
        this.paperDataModal = false
        let error = data.error.replace(/;/g, '\n')
        this.$warning({
          title: '请先设置分数',
          content: error,
          okText: '知道了'
        })
      }
    } catch (e) {
      console.log(e)
    }
  }
  public async submitTransEvaluationInfo() {
    let book_id: any = ''
    if (this.useType === 'UNIT_TEST') {
      book_id = this.lib
    } else {
      book_id = this.book
    }
    // 考试类型非空校验
    if (!this.useType) {
      this.$message.warning('请选择考试类型！')
      return
    }
    this.syncBtnLoading = true
    try {
      let count = 0
      let { data, success, error }: any = await postTransEvaluation({
        subject_id: this.subjectId,
        usage: 3,
        book_id,
        use_type: this.useType
      })
      if (success) {
        this.getSource(data.task_id, count, this.subjectId)
      } else {
        this.syncBtnLoading = false // loading结束
        this.$message.warning(error)
      }
    } catch (e) {
      this.syncBtnLoading = false // loading结束
      this.paperDataModal = false // 关闭弹窗
    }
  }
  public async getSource(task_id: number, count: number, subject_id: string) {
    try {
      let data: any = await assessmentPaperGetPaperId({ task_id })
      if (data.success) {
        this.syncBtnLoading = false // loading结束
        this.paperDataModal = false // 关闭弹窗
        let targetWindow = window.opener && window.opener.opener
        let paper_id = data.data && data.data.paper_id
        if (paper_id) {
          window['sensors'].track('Assessmentpreview_testinformation_Confirm', {
            save_status: '成功'
          })
          // tslint:disable-next-line:no-unused-expression
          targetWindow && targetWindow.postMessage({ paper_id }, '*')
          let secondsToGo = 5
          const modal: any = this.$success({
            okText: '知道了',
            title: `组卷成功，${secondsToGo}秒后自动跳转至发布${this.titleText}`,
            width: '400px',
            content: (h) => {
              return h('div', {}, [h('p', '本试卷已保存至「我的试卷」')])
            },
            maskClosable: false,
            keyboard: false,
            onOk: () => {
              this.trackPublish('去发布', proSource)
              clearInterval(interval)
              modal.destroy()
              this.$router.replace({
                path: '/assessment/publish',
                query: {
                  subject: this.subject.nick,
                  subject_id: this.subjectId,
                  pid: paper_id,
                  s: 'PERSONAL_ASSESSMENT',
                  f: encodeURIComponent(proSource)
                }
              })
            }
          })
          const interval = setInterval(() => {
            secondsToGo -= 1
            modal.update({
              title: `组卷成功，${secondsToGo}秒后自动跳转至发布${this.titleText}`
            })
          }, 1000)
          setTimeout(() => {
            this.trackPublish('去发布', proSource)
            clearInterval(interval)
            modal.destroy()
            this.$router.replace({
              path: '/assessment/publish',
              query: {
                subject: this.subject.nick,
                subject_id: this.subjectId,
                pid: paper_id,
                s: 'PERSONAL_ASSESSMENT',
                f: encodeURIComponent(proSource)
              }
            })
          }, secondsToGo * 1000)
        } else {
          this.$message.warning(data.data.msg)
          window['sensors'].track('Assessmentpreview_testinformation_Confirm', {
            save_status: '失败'
          })
        }
      } else {
        if (count > 3000) {
          this.syncBtnLoading = false // loading结束
          this.paperDataModal = false // 关闭弹窗
          this.$message.warning('请求超时，请重新同步！')

          window['sensors'].track('Assessmentpreview_testinformation_Confirm', {
            save_status: '失败'
          })
        } else {
          count = count + 1
          // 失败之后1秒以后查询
          setTimeout(() => {
            this.getSource(task_id, count, subject_id)
          }, 1000)
        }
      }
    } catch (e) {
      this.syncBtnLoading = false
    }
  }
  public showConfirmModal() {
    window['sensors'].track('TIKU_Assessment_organizingPaper_clk', {
      buttonName: '完成组卷'
    })
    if (!this.totalScore || this.totalScore == 0) {
      this.$message.warning('请设置试卷分数！')
      return
    }
    if (!this.useType) {
      this.$message.warning('请选择考试类型！')
      return
    }
    if (this.useType === 'UNIT_TEST') {
      if (!this.lib || this.lib.length === 0) {
        this.$message.warning('请选择关联单元！')
        return
      }
    } else {
      if (!this.book || this.book.length === 0) {
        this.$message.warning('请选择关联教材！')
        return
      }
    }
    this.getScoreReq()
    this.$confirm({
      okText: '是',
      cancelText: '否',
      title: '分数确认',
      content: (h) => {
        return h('div', {}, `当前试卷总分为${this.paper_total_score}分，是否要调整分数？`)
      },
      maskClosable: false,
      keyboard: false,
      onOk: () => {
        // 两秒之后跳转到测评主页
        this.setScore('保存至评测')
      },
      onCancel: () => {
        // this.getPaperEvaluationInfo()
        // this.getBookSeries()
        this.submitTransEvaluationInfo()
      }
    })
  }
  public confirmPaperData() {
    // this.submitTransEvaluationInfo()
    this.paperDataModal = false

    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '确定'
    })
  }
  public onUsetypeChange(value, option) {
    this.useType = value
    this.useTypeName = option.data.attrs.text
    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '考试类型'
    })
  }
  public onLibSelect(value, option) {
    this.lib = value
    this.libName = option.data.attrs.text
    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '关联章节'
    })
  }
  public async onBookSelect(value, option) {
    this.lib = []
    this.book = value
    this.bookName = option.data.attrs.text
    this.getBooks(value, 'UNIT', 'libs')

    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '关联书册'
    })
  }
  public async onSeriesChange(value, option) {
    this.book = []
    this.serie = value
    this.serieName = option.data.attrs.text
    this.getBooks(value, 'BOOK', 'books')

    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '教材系列'
    })
  }
  public async getBookSeries() {
    try {
      let data: any = await getSeries({ subject_id: this.subjectId })
      console.log(data)
      if (data.success) {
        this.bookSeries = data.data
      } else {
        this.bookSeries = []
      }
    } catch (e) {
      console.log(e)
    }
  }
  public async getBooks(book_catalog_id, book_catalog_level, module) {
    try {
      let data: any = await getBooks({
        subject_id: this.subjectId,
        book_catalog_id,
        book_catalog_level
      })
      if (data.success) {
        // tslint:disable-next-line:no-unused-expression
        this[module] = data.data
      } else {
        this[module] = []
      }
    } catch (e) {
      console.log(e)
    }
  }
  public cancelPaperData() {
    this.paperDataModal = false

    window['sensors'].track('Assessmentpreview_testinformationpop_buttonClick', {
      buttonName: '取消'
    })
  }
  // 更改试卷中试题类型标题
  public onBusinessTypeChange(item) {
    item.business_type = item.business_type && item.business_type.replace(/\s+/g, '') // 去除空格
    // 同步试卷信息
    if (!item.business_type) {
      item.business_type = '未命名题型'
    }
    this.updateCart(this.paperData)
  }
  public async getScoreReq() {
    let { data, success }: any = await questionScores({ subject_id: this.subjectId, usage })
    this.paper_total_score = 0
    if (success) {
      this.scoreData = data.classification.map((n, index) => {
        this.paper_total_score += n.group_score
        // 计算题目序号
        // 空数据双向绑定
        let count = 0
        n.group_once = ''
        for (let i = 0; i < index; i++) {
          count += data.classification[i].sequence.length
        }
        n.sequence.map((q, idx) => {
          q.idx = count + idx + 1
          q.sub_scores = q.sub_scores.map((row, m) => {
            let copy = row.map((space, n) => {
              return {
                score: space
              }
            })
            return copy
          })

          return q
        })
        return n
      })
      console.log(this.scoreData)
    } else {
      this.scoreData = []
    }
  }
  public async onScoreConfirm() {
    let classification = this.scoreData.map((m) => {
      m.sequence = m.sequence.map((n) => {
        let score = 0
        // console.log(n)
        n.interval_score = parseFloat(n.interval_score)
        n.sub_scores = n.sub_scores.map((i) => {
          return i.map((j) => {
            score += parseFloat(j.score)
            return parseFloat(j.score)
          })
        })
        n.score = score
        return n
      })
      return m
    })
    // console.log(classification)
    let params = {
      subject_id: this.subjectId,
      usage,
      classification
    }

    window['sensors'].track('Assessmentpreview_scoresettingpop_buttonClick', {
      buttonName: '确定'
    })

    try {
      let data: any = await setScores(params)
      if (data.success) {
        this.scoreModal = false
        this.getDetail()
      } else {
        this.scoreModal = false
      }
    } catch (e) {
      this.scoreModal = false
    }
  }
  public setScore(origin?: string) {
    this.getScoreReq()
    this.scoreModal = true
    window['sensors'].track('TIKU_Assessment_organizingPaper_clk', {
      buttonName: '设置分值'
    })
    // window['sensors'].track('Assessmentpreview_scoresettingpop_loading', {
    //   origin
    // })
  }
  public setPaper() {
    window['sensors'].track('TIKU_Assessment_organizingPaper_clk', {
      buttonName: '设置试卷信息'
    })
    this.getPaperEvaluationInfo()
    this.getBookSeries()
  }
  public handleCancelScoreset() {
    this.scoreModal = false

    window['sensors'].track('Assessmentpreview_scoresettingpop_buttonClick', {
      buttonName: '取消'
    })
  }
  public onAnchorChange() {
    window['sensors'].track('Assessmentpreview_scoresettingpop_buttonClick', {
      buttonName: '题组锚点按钮'
    })
  }
  public rowScore(score, row) {
    let total = 0
    for (let n of row.sub_scores) {
      for (let m of n) {
        let s = parseFloat(m.score) || 0
        total = Add(total, s)
      }
    }
    score = total || 0
    return score
  }
  public onInputNumberChange(space: any) {
    const score = String(space.score)
    const digits = (score.split('.')[1] || '').length
    if (!(typeof space.score === 'number' && !isNaN(space.score))) return
    if (digits > 1) {
      space.score = parseFloat(parseFloat(score).toFixed(1))
    }
  }
  public onInputNumberBlur(space: any, row) {
    // 当有跨度值的时候需要校验是分数否分跨度值的正整数倍
    if (row.have_interval_score) {
      if (space.score % row.interval_score !== 0) {
        this.$message.warning('"分数"必须是"跨度值"的整数倍！')
        space.score = 1
      }
    }
  }
  public onOnceSetChange(score, arr) {
    console.log(score, arr)
  }
  public onOnceSetBlur(score, arr) {
    console.log(score, arr)
    arr.forEach((item) => {
      item.sub_scores.forEach((itm) => {
        itm.forEach((n) => {
          n.score = score
        })
      })
    })
    console.log(arr)
  }
  // 添加题组 添加一个空题组
  public addQType() {
    let newType = {
      business_type: '未命名题型',
      sequence: []
    }
    this.paperData.push(newType)
    this.updateCart(this.paperData)

    window['sensors'].track('TIKU_Assessment_organizingPaper_clk', {
      buttonName: '添加题组'
    })
  }
  // 移除题组
  public onDeleteQtype(index, item) {
    this.$confirm({
      title: '确定删除此题组吗？',
      content: '若删除，此题组下的所有试题将全部移除！',
      okText: '确定',
      cancelText: '取消',
      icon: 'info-circle',
      onOk: () => {
        this.paperData.splice(index, 1) // 直接删除
        this.updateCart(this.paperData) // 更新试题篮

        window['sensors'].track('Assessmentpreview_buttonClick', {
          buttonName: '删除题组'
        })
      },
      onCancel: () => {
        // this.setScore()
      }
    })
  }
  // 试题
  public async cartDelete(id: number | string) {
    let param: any = {
      question_id: id,
      subject_id: this.subjectId,
      usage
    }

    let data: any = await removeUestionFromCart(param)
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.getDetail()
    }
  }
  public async addToCart(val) {
    this.cartDelete(val.id)
  }
  public handleNumber(idx, questons, index, classification) {
    let count = 0
    if (index === 0) {
      return idx
    } else {
      for (let i = 0; i < index; i++) {
        count += classification[i].sequence.length
      }
      return count + idx
    }
  }
  public async getCart() {
    let params: any = {
      subject_id: this.subjectId,
      usage
    }

    let data: any = await getQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
    } else {
      if (data.error === '请登录') {
        this.$store.commit('SET_CART', { classification: {}, question_ids: [], title: '' })
      }
    }
  }
  public handleData(data) {
    data.forEach((element) => {
      element.sequence.forEach((n) => {
        n.inShoppingCart = true
        n.showAnalysis = false
      })
    })
    this.paperData = data
    console.log(this.paperData)
  }
  public async getDetail() {
    this.lazying = true
    let params: any = {
      subject_id: this.subjectId,
      usage
    }
    try {
      let data: any = await listDetail(params)
      this.lazying = false
      if (data.success) {
        this.handleData(data.data.classification)

        console.log(new Date().getSeconds())
        this.$nextTick(() => {
          console.log(new Date().getSeconds())
        })

        window['sensors'].track('Assessmentpreview_loading', {
          types: (data.data && data.data.classification.length) || 0,
          questions: (data.data && data.data.question_ids.length) || 0
        })
      } else {
        this.paperData = []
      }
    } catch (e) {
      this.paperData = []
      this.lazying = false
    }
  }
  public dragEnd() {
    // console.log(this.paperData)
    this.updateCart(this.paperData)
  }
  public checkMove(evt) {
    console.log(evt)
    evt.draggedContext.element.name = 'target'
  }
  // 同步更新试卷信息
  public async updateCart(data) {
    let dataCopy = JSON.parse(JSON.stringify(data))
    let classification = dataCopy.map((item) => {
      item.sequence = item.sequence.map((n) => n.id)
      return item
    })
    let question_ids = []
    for (let n of classification) {
      question_ids = question_ids.concat(n.sequence)
    }
    console.log(question_ids)
    let params: any = {
      question_cart: {
        question_ids,
        classification
      },
      subject_id: this.subjectId,
      usage
    }
    try {
      let res: any = await updateQuestionCart(params)
      if (res.success) {
        this.$store.commit('SET_CART', res.data)
      } else {
        this.$message.warning(res.error)
      }
      this.getDetail()
    } catch (e) {
      console.log(e)
    }
  }
  // 按难度排序
  public onClickDifficulty(m, item, data) {
    item.sequence = [...bubbling(item.sequence, m.key)]
    // console.log(data)
    this.updateCart(data)

    window['sensors'].track('Assessmentpreview_buttonClick', {
      buttonName: m.key == '1' ? '难度由低到高' : '难度由高到低'
    })
  }
}
